package dev.lingvo.ops.pages.workspaces.orgId

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.style.toModifier
import dev.lingvo.ops.api.OpsApi
import dev.lingvo.ops.components.OpsFact
import dev.lingvo.ops.components.OpsPageHeader
import dev.lingvo.ops.components.OpsPanel
import dev.lingvo.ops.components.OpsProseStyle
import dev.lingvo.ops.components.OpsResourceStates
import dev.lingvo.ops.components.OpsShell
import dev.lingvo.ops.components.OpsUntrustedText
import dev.lingvo.ops.components.OpsWorkspaceNav
import dev.lingvo.ops.state.keyState
import dev.lingvo.ops.state.overrideNote
import dev.lingvo.ops.state.rememberOpsResource
import dev.lingvo.site.ds.Space
import dev.lingvo.site.ds.formatUtc
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Page("/workspaces/{orgId}/providers")
@Composable
fun ProvidersPage() {
    val id = rememberPageContext().route.params["orgId"].orEmpty()
    OpsShell("Providers") {
        val resource = rememberOpsResource(id) { OpsApi.providers(id) }

        Column(Modifier.fillMaxWidth().gap(Space.XL)) {
            OpsWorkspaceNav(id, "Providers"); OpsPageHeader("Providers", "Read stored provider configuration and server verdicts. Credentials remain private.", resource.state.isRefreshing, resource::refresh)
            OpsResourceStates(resource.state, "No providers", "No provider configuration is recorded.", retry = resource::refresh) { result ->
                OpsPanel("Server verdict", result.verdict, content = { P(OpsProseStyle.toModifier().toAttrs()) { Text(result.verdict) } })
                OpsPanel("Workspace providers") { result.workspace.forEach { row -> P { Text("${row.provider.displayName} · ${if (row.enabled) "Enabled" else "Disabled"} · ${keyState(row.hasKey, row.keyUnreadable).name} · "); OpsUntrustedText(row.baseUrl); Text(" · tested ${formatUtc(row.testedOkAt)}") } } }
                OpsPanel("Project overrides") { result.projectOverrides.forEach { row -> P { Text("${row.projectName} · ${overrideNote(row.mode, row.hasKey, row.keyUnreadable) ?: "Inherited"}") } } }
                OpsPanel("Platform keys") { result.platformKeys.forEach { (provider, present) -> OpsFact(provider, if (present) "Stored" else "None") } }
                OpsPanel("Recent failures") { OpsFact("Unreadable keys", result.unreadableKeyCount.toString()) }
                OpsPanel("What this page cannot tell you") { P { Text("Whether the provider accepts the key right now is a question only a run can answer. This page reads what Lingvo stored.") } }
            }
        }
    }
}
